<template>
	<div class="card mb-2">
		<div class="card-header">
			<span class="text-left">
				Számlázási azonosítók
			</span>
			<span class="float-right pointer">
				<i
					class="fa-solid fa-lg fa-chevron-down"
					v-if="show_body == false"
					@click="show_body = true"
				>
				</i>
				<i
					class="fa-solid fa-lg fa-chevron-up"
					v-if="show_body == true"
					@click="show_body = false"
				>
				</i>
			</span>
		</div>
		<div class="card-body" v-if="show_body">
			<!--<div class="row d-flex">
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<div class="mui-textfield mui-textfield">
				    	<input type="text" v-model="maverix_id">
				    	<label>Maverix azonosító</label>
					</div>
				</div>
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<button
						class="btn btn-primary"
						@click.prevent="saveMaverix"
					>
						Mentés
					</button>
				</div>
			</div>-->
				
			<div class="table-responsive">
				<table class="table table-striped">
					<thead>
						<th>Szolgáltató</th>
						<th>Billingo ID</th>
						<th>Művelet</th>
					</thead>
					<tbody>
						<tr
							v-for="(v,k) in szolg"
							:key="k"
						>
							<td>{{ v.nev }} - {{ v.megjegyzes }}</td>
							<td
							>
								<span v-if="v.billingo_id">
									{{ v.billingo_id }}
								</span>
								<button
									class="btn btn-warning"
									v-else
									@click="showSetBillingoID(v)"
								>
									Megadom az azonosítót
								</button>
								<span v-if="v.id == 1 && isAdmin == true">
									<button
										class="btn btn-warning"
										@click="showUpdateBillingoID(v,v.billingo_id)"
									>
										Szerkesztés
									</button>
								</span>
							</td>
							<td>
								<button
									class="btn btn-primary"
									v-if="!v.billingo_id"
									@click="insert(v)"
								>
									Létrehozás
								</button>
								<button
									class="btn btn-success"
									v-else
									@click="update(k)"
									disabled
								>
									Frissít
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div
			class="modal fade"
			id="addbillingoid"
		>
			<div class="modal-dialog">
				<div class="modal-content">
	  				<div class="modal-body">
	    				<div class="mui-textfield mui-textfield--float-label">
					    	<input
					    		type="text"
					    		v-model="billingo_id"
					    	>
					    	<label>Ügyfél Billingo azonosítója</label>
					  	</div>
	  				</div>
	  					<div class="modal-footer">
	    				<button
	    					type="button"
	    					class="btn btn-secondary"
	    					@click.prevent="close"
	    				>
	    					Mégsem
	    				</button>
	    				<button
	    					type="button"
	    					v-if="update_billingo == false"
	    					class="btn btn-primary"
	    					@click.prevent="save"
	    				>
	    					Mentés
	    				</button>
	    				<button
	    					type="button"
	    					v-if="update_billingo == true"
	    					class="btn btn-primary"
	    					@click.prevent="update"
	    				>
	    					Frissít
	    				</button>	    				
	  				</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	props: ['customer'],

	data() {
		return {
			szolg: [],
			billingo_id: null,
			maverix_id: null,
			szla_szolg: null,
			update_billingo: false,
			show_body: false
		}
	},

	created() {
		this.init()
	},

	methods: {
		init() {
			this.update_billingo = false
			this.$Progress.start()
			this.req.get('/customers/billingo/idlist/' + this.customer.uszam)
				.then(res => {
					this.szolg = res.data.szolg
					this.$Progress.finish()
				})
				.catch(err => {
					console.error(err)
					toastr.error(err)
	    			this.$Progress.fail()
				})
			this.$Progress.start()
			this.req.get('/customers/maverix/id/' + this.customer.uszam)
				.then(res => {
					this.maverix_id = res.data.id || null
					this.$Progress.finish()
				})
				.catch(err => {
					console.error(err)
					toastr.error(err)
	    			this.$Progress.fail()
				})
		},
		
		showUpdateBillingoID(szolg,bid) {
			this.szla_szolg = szolg.id
			this.billingo_id = bid
			this.update_billingo = true
			$('#addbillingoid').modal('show')
		},

		showSetBillingoID(szolg) {
			this.szla_szolg = szolg.id
			$('#addbillingoid').modal('show')
		},

		close() {
			this.billingo_id = null
        	$('#addbillingoid').modal('hide')
		},

		saveMaverix() {
			this.$Progress.start()
			this.req.post('/customers/maverix/id', {
				uszam: this.customer.uszam,
				maverix_id: this.maverix_id
			})
				.then(res=>{
					this.$Progress.finish()
					toastr.success('Mentés ok')
    				this.init()
    			})
    			.catch(err=>{
    				console.error(err)
    				this.$toast.error(err.response.data.text || err)
    				this.$Progress.fail()
    			})
		},

		update() {
			this.$Progress.start()
			this.req.post('/customers/billingo/updateID', {
    			uszam: this.customer.uszam,
    			szla_szolg: this.szla_szolg,
    			billingo_id: this.billingo_id
    		})
    			.then(res=>{
    				$('#addbillingoid').modal('hide')
    				this.szla_szolg = null
    				this.billingo_id = null
    				this.update_billingo = false
    				this.init()
    			})
    			.catch(err=>{
    				console.error(err)
    				this.$toast.error(err.response.data.text || err)
    				this.$Progress.fail()
    			})
		},

		save() {
			this.$Progress.start()
			this.req.post('/customers/billingo/insertID', {
    			uszam: this.customer.uszam,
    			szla_szolg: this.szla_szolg,
    			billingo_id: this.billingo_id
    		})
    			.then(res=>{
    				$('#addbillingoid').modal('hide')
    				this.szla_szolg = null
    				this.billingo_id = null
    				this.init()
    			})
    			.catch(err=>{
    				console.error(err)
    				this.$toast.error(err.response.data.text || err)
    				this.$Progress.fail()
    			})
		},

		insert(szolg) {
			this.$Progress.start()
			this.req.post('/customers/billingo/insert', {
    			customer: this.customer,
    			szla_szolg: szolg.id
    		})
    			.then(res=>{
    				this.init()
    			})
    			.catch(err=>{
    				console.error(err)
    				this.$toast.error(err.response.data.text || err)
    				this.$Progress.fail()
    			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/customers/customer_billingo.vue